import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import "./css/common.css";
import locale from 'element-ui/lib/locale/lang/en'
import {VueMasonryPlugin} from 'vue-masonry';
import App from './App';
import { store } from './store.js';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';
// import VueAuth from '@websanova/vue-auth';

Vue.config.productionTip = false;

const token = localStorage.getItem('jwt')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer '+token;
}

Vue.use(ElementUI, { locale })
Vue.use(VueMasonryPlugin)
Vue.use(VueAxios, axios);

// Vue.use(VueAuth, {
//   auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
//   http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
//   router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js')
// });


/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js